import { DATE_YMD, END_OF_MONTH, FORMAT_DATE, START_OF_MONTH, TODAY, TOMORROW } from '..';
import { IS_NOT_NULL_OR_UNDEFINED } from './../../utils/commonUtils';
import { IS_NOT_EMPTY } from './../../utils/stringUtils';
import { Params } from './Params';

export const GET_QUERY_PARAMS = (param: any): any => {
	let newPayload: Params = {
		searchTerm: '',
		isBroker: true,
		isCarrier: true,
		isShipper: true,
		isPartner: true,
		mappedCarriersOptions: true,
		plan: 0,
		isSubscriptionColumn: false,
		myAccounts: false,
		searchField: 'businessName',
		selectedUserIds: [],
		stageId: '',
		accountIds: '',
		inNetwork: false,
		withoutLanes: false,
		nextContactDate: '',
		selectedAccountIds: [],
		businessName: '',
		mappedCarriers: '',
		originCity: '',
		originState: '',
		destinationCity: '',
		destinationState: '',
		trailerType: '',
		destinationStates: '',
		needsReview: false,
		totalLanes: null,
		startDate: START_OF_MONTH(),
		endDate: END_OF_MONTH(),
		email: '',
		admin: true,
		destination: null,
		origin: null,
		pickupDate: FORMAT_DATE(new Date(), 'MM/DD/YYYY'),
		pickupDateStart: FORMAT_DATE(TODAY(), 'MM/DD/YYYY'),
		pickupDateEnd: FORMAT_DATE(TOMORROW(), 'MM/DD/YYYY'),
		carrierFilterSelected: '',
		searchDate: '',
		totalEmailCount: null,
		assignedToMe: false,
		hazmat: false,
		trailerTypes: [],
		powerUnits : null,
		notesContent: '',
		mc: '',
		dot: '',
		hasTeams: false,
		city: ''
	};
	if (IS_NOT_NULL_OR_UNDEFINED(param)) {
		if (IS_NOT_NULL_OR_UNDEFINED(param.searchTerm) && IS_NOT_EMPTY(param.searchTerm)) {
			newPayload.searchTerm = param.searchTerm;
		} else {
			newPayload.searchTerm = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.isBroker) && IS_NOT_EMPTY(param.isBroker)) {
			newPayload.isBroker = param.isBroker === 'true';
		} else {
			newPayload.isBroker = true;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.isCarrier) && IS_NOT_EMPTY(param.isCarrier)) {
			newPayload.isCarrier = param.isCarrier === 'true';
		} else {
			newPayload.isCarrier = true;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.isShipper) && IS_NOT_EMPTY(param.isShipper)) {
			newPayload.isShipper = param.isShipper === 'true';
		} else {
			newPayload.isShipper = true;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.isPartner) && IS_NOT_EMPTY(param.isPartner)) {
			newPayload.isPartner = param.isPartner === 'true';
		} else {
			newPayload.isPartner = true;
		}
		if (
			IS_NOT_NULL_OR_UNDEFINED(param.mappedCarriersOptions) &&
			IS_NOT_EMPTY(param.mappedCarriersOptions)
		) {
			newPayload.mappedCarriersOptions = param.mappedCarriersOptions === 'true';
		} else {
			newPayload.mappedCarriersOptions = true;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.plan) && IS_NOT_EMPTY(param.plan)) {
			newPayload.plan = +param.plan;
		} else {
			newPayload.plan = 0;
		}
		if (
			IS_NOT_NULL_OR_UNDEFINED(param.isSubscriptionColumn) &&
			IS_NOT_EMPTY(param.isSubscriptionColumn)
		) {
			newPayload.isSubscriptionColumn = param.isSubscriptionColumn === 'true';
		} else {
			newPayload.isSubscriptionColumn = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.myAccounts) && IS_NOT_EMPTY(param.myAccounts)) {
			newPayload.myAccounts = param.myAccounts === 'true';
		} else {
			newPayload.myAccounts = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.searchField) && IS_NOT_EMPTY(param.searchField)) {
			newPayload.searchField = param.searchField;
		} else {
			newPayload.searchField = 'businessName';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.selectedUserIds) && param.selectedUserIds.length > 0) {
			newPayload.selectedUserIds = JSON.parse(param.selectedUserIds);
		} else {
			newPayload.selectedUserIds = [];
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.stageId) && IS_NOT_EMPTY(param.stageId)) {
			newPayload.stageId = param.stageId;
		} else {
			newPayload.stageId = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.accountIds) && IS_NOT_EMPTY(param.accountIds)) {
			newPayload.accountIds = param.accountIds;
		} else {
			newPayload.accountIds = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.inNetwork) && IS_NOT_EMPTY(param.inNetwork)) {
			newPayload.inNetwork = param.inNetwork === 'true';
		} else {
			newPayload.inNetwork = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.withoutLanes) && IS_NOT_EMPTY(param.withoutLanes)) {
			newPayload.withoutLanes = param.withoutLanes === 'true';
		} else {
			newPayload.withoutLanes = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.nextContactDate) && IS_NOT_EMPTY(param.nextContactDate)) {
			newPayload.nextContactDate = JSON.parse(param.nextContactDate);
		} else {
			newPayload.nextContactDate = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.selectedAccountIds) && param.selectedAccountIds.length > 0) {
			newPayload.selectedAccountIds = JSON.parse(param.selectedAccountIds);
		} else {
			newPayload.selectedAccountIds = [];
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.businessName) && IS_NOT_EMPTY(param.businessName)) {
			newPayload.businessName = param.businessName;
		} else {
			newPayload.businessName = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.mappedCarriers) && IS_NOT_EMPTY(param.mappedCarriers)) {
			newPayload.mappedCarriers = param.mappedCarriers === 'true';
		} else {
			newPayload.mappedCarriers = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.originCity) && IS_NOT_EMPTY(param.originCity)) {
			newPayload.originCity = param.originCity;
		} else {
			newPayload.originCity = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.originState) && IS_NOT_EMPTY(param.originState)) {
			newPayload.originState = param.originState;
		} else {
			newPayload.originState = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.destinationCity) && IS_NOT_EMPTY(param.destinationCity)) {
			newPayload.destinationCity = param.destinationCity;
		} else {
			newPayload.destinationCity = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.destinationState) && IS_NOT_EMPTY(param.destinationState)) {
			newPayload.destinationState = param.destinationState;
		} else {
			newPayload.destinationState = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.trailerType) && IS_NOT_EMPTY(param.trailerType)) {
			newPayload.trailerType = param.trailerType;
		} else {
			newPayload.trailerType = 'VAN';
		}
		if (
			IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
			IS_NOT_EMPTY(param.destinationStates)
		) {
			newPayload.destinationStates = param.destinationStates;
		} else {
			newPayload.destinationStates = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.needsReview)) {
			newPayload.needsReview = param.needsReview === 'true';
		} else {
			newPayload.needsReview = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.totalLanes) && IS_NOT_EMPTY(param.totalLanes)) {
			newPayload.totalLanes = +param.totalLanes;
		} else {
			newPayload.totalLanes = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.startDate) && IS_NOT_EMPTY(param.startDate)) {
			newPayload.startDate = param.startDate;
		} else {
			newPayload.startDate = START_OF_MONTH();
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.endDate) && IS_NOT_EMPTY(param.endDate)) {
			newPayload.endDate = param.endDate;
		} else {
			newPayload.endDate = END_OF_MONTH();
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.email) && IS_NOT_EMPTY(param.email)) {
			newPayload.email = param.email;
		} else {
			newPayload.email = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.destination) && IS_NOT_EMPTY(param.destination)) {
			newPayload.destination = JSON.parse(param.destination);
		} else {
			newPayload.destination = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.origin) && IS_NOT_EMPTY(param.origin)) {
			newPayload.origin = JSON.parse(param.origin);
		} else {
			newPayload.origin = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDate) && IS_NOT_EMPTY(param.pickupDate)) {
			newPayload.pickupDate = param.pickupDate;
		} else {
			newPayload.pickupDate = FORMAT_DATE(new Date(), 'MM/DD/YYYY');
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.admin)) {
			newPayload.admin = param.admin === 'true';
		} else {
			newPayload.admin = true;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDateStart) && IS_NOT_EMPTY(param.pickupDateStart)) {
			newPayload.pickupDateStart = param.pickupDateStart;
		} else {
			newPayload.pickupDateStart = DATE_YMD(TODAY());
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDateEnd) && IS_NOT_EMPTY(param.pickupDateEnd)) {
			newPayload.pickupDateEnd = param.pickupDateEnd;
		} else {
			newPayload.pickupDateEnd = DATE_YMD(TOMORROW());
		}
		if (
			IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
			IS_NOT_EMPTY(param.destinationStates)
		) {
			newPayload.destinationStates = param.destinationStates;
		} else {
			newPayload.destinationStates = '';
		}
		if (
			IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
			IS_NOT_EMPTY(param.destinationStates)
		) {
			newPayload.destinationStates = param.destinationStates;
		} else {
			newPayload.destinationStates = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.searchDate) && IS_NOT_EMPTY(param.searchDate)) {
			newPayload.searchDate = param.searchDate;
		} else {
			newPayload.searchDate = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.carrierFilterSelected) && IS_NOT_EMPTY(param.carrierFilterSelected)) {
			newPayload.carrierFilterSelected = param.carrierFilterSelected;
		} else {
			newPayload.carrierFilterSelected = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.totalEmailCount) && IS_NOT_EMPTY(param.totalEmailCount)) {
			newPayload.totalEmailCount = +param.totalEmailCount;
		} else {
			newPayload.carrierFilterSelected = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.assignedToMe)) {
			newPayload.assignedToMe = param.assignedToMe === 'true';
		} else {
			newPayload.assignedToMe = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.hasTeams)) {
			newPayload.hasTeams = param.hasTeams === 'true';
		} else {
			newPayload.hasTeams = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.hazmat)) {
			newPayload.hazmat = param.hazmat === 'true';
		} else {
			newPayload.hazmat = false;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.mc) && IS_NOT_EMPTY(param.mc)) {
			newPayload.mc = param.mc;
		} else {
			newPayload.mc = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.dot) && IS_NOT_EMPTY(param.dot)) {
			newPayload.dot = param.dot;
		} else {
			newPayload.dot = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.notesContent) && IS_NOT_EMPTY(param.notesContent)) {
			newPayload.notesContent = param.notesContent;
		} else {
			newPayload.notesContent = '';
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.trailerTypes) && IS_NOT_EMPTY(param.trailerTypes)) {
			newPayload.trailerTypes = param.trailerTypes.split(',');
		} else {
			newPayload.trailerTypes = [];
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.powerUnits) && IS_NOT_EMPTY(param.powerUnits)) {
			newPayload.powerUnits = +param.powerUnits;
		} else {
			newPayload.powerUnits = null;
		}
		if (IS_NOT_NULL_OR_UNDEFINED(param.city) && IS_NOT_EMPTY(param.city)) {
			newPayload.city = param.city;
		} else {
			newPayload.city = '';
		}
		return newPayload;
	}
};
